(function ($) {
  // Document Ready
  $(document).ready(function () {
    console.log("theme.js initiated");

    var isMobile = window.matchMedia("only screen and (max-width: 768px)").matches;

    // Add nav height calculation
    var navheight = $("#main-nav").outerHeight(true);
    document.documentElement.style.setProperty("--navHeight", navheight + "px");

    // Combine with existing window events
    $(window)
      .off("scroll resize")
      .on("scroll resize", function (event) {
        // Handle scroll events
        var scrolledFromTop = $(window).scrollTop();
        if (scrolledFromTop > 20) {
          $("body").addClass("scrolled");
        } else {
          $("body").removeClass("scrolled");
        }

        // Update nav height on resize
        if (event.type === "resize") {
          var navheight = $("#main-nav").outerHeight(true);
          document.documentElement.style.setProperty("--navHeight", navheight + "px");
        }
      });

    // Menu Button Click Events
    // –> need to use the .off here to remove event handlers that were previously attached to elements
    // –> then we re-attach them
    $("#menu-btn")
      .off("click")
      .on("click", function () {
        const isExpanded = $("body").hasClass("menu-open");
        const navMenu = $("#navmenu");

        if (isExpanded) {
          // Close menu and collapse any open sub-menus
          $("body").removeClass("menu-open");
          $("#menu-btn").attr("aria-expanded", "false");
          navMenu.prop("hidden", true);
          navMenu.find(".menu-item-has-children.sub-menu-open").each(function () {
            $(this).removeClass("sub-menu-open");
            $(this).find("> a").attr("aria-expanded", "false");
          });
        } else {
          // Open menu
          $("body").addClass("menu-open");
          $("#menu-btn").attr("aria-expanded", "true");
          navMenu.prop("hidden", false);
        }
      });

    // Mobile sub-menu toggle
    // On desktop the sub-menu is revealed via CSS :hover; this handler
    // is intentionally no-op above the mobile breakpoint.
    $("#navmenu")
      .off("click.submenu")
      .on("click.submenu", ".menu-item-has-children > a", function (e) {
        if (!window.matchMedia("only screen and (max-width: 768px)").matches) return;

        e.preventDefault();

        var $parentLi = $(this).closest(".menu-item-has-children");
        var isOpen = $parentLi.hasClass("sub-menu-open");

        $parentLi.toggleClass("sub-menu-open");
        $(this).attr("aria-expanded", isOpen ? "false" : "true");
      });

    $(".testimonials-carousel .owl-carousel").each(function () {
      $(this).owlCarousel({
        loop: true,
        autoplay: false,
        autoHeight: true,
        items: 1,
        dots: false,
        nav: true,
        navText: [
          '<span class="visuallyhidden">Click to view the previous</span><svg xmlns="http://www.w3.org/2000/svg" width="91" height="91" viewBox="0 0 91 91"><g id="Group_25996" data-name="Group 25996" transform="translate(-64 -3475)"><circle id="Ellipse_165" data-name="Ellipse 165" cx="45.5" cy="45.5" r="45.5" transform="translate(64 3475)" fill="#192a58"/><path id="Arrow" d="M18,7.5,33.952,23.452,18,39.4" transform="translate(131.987 3543.975) rotate(180)" fill="none" stroke="#ebad62" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/></g></svg>',
          '<span class="visuallyhidden">Click to view the next</span><svg xmlns="http://www.w3.org/2000/svg" width="91" height="91" viewBox="0 0 91 91"><g id="Group_25996" data-name="Group 25996" transform="translate(-64 -3475)"><circle id="Ellipse_165" data-name="Ellipse 165" cx="45.5" cy="45.5" r="45.5" transform="translate(64 3475)" fill="#192a58"/><path id="Arrow" d="M18,7.5,33.952,23.452,18,39.4" transform="translate(131.987 3543.975) rotate(180)" fill="none" stroke="#ebad62" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"/></g></svg>',
        ],
      });
    });

    /*****************************************************************
      Accordions
    *****************************************************************/

    if ($(".accordion").length) {
      $(".accordion-tab button").click(function (event) {
        var me = $(this),
          accordionTab = $(this).closest(".accordion-tab"),
          accordionContainer = $(this).closest(".accordion-container"),
          content = accordionTab.find("dd"),
          contentHeight = content.find(".content").outerHeight(true);

        console.log("accordionTab", accordionTab);
        console.log("accordionContainer", accordionContainer);
        console.log("content", content);
        console.log("contentHeight", contentHeight);

        // Toggle current accordion
        if (accordionTab.hasClass("open")) {
          // Close current accordion
          accordionTab.removeClass("open");
          me.attr("aria-expanded", "false");
          content.attr("aria-hidden", "true");
          content.css({
            "max-height": "0",
            position: "relative",
          });
        } else {
          // Close all accordions in the same container
          accordionContainer.find(".accordion-tab").each(function () {
            var tab = $(this);
            tab.removeClass("open");
            tab.find("button").attr("aria-expanded", "false");
            tab.find("dd").attr("aria-hidden", "true").css({
              "max-height": "0",
              position: "relative",
            });
          });

          // Open clicked accordion
          accordionTab.addClass("open");
          me.attr("aria-expanded", "true");
          content.attr("aria-hidden", "false");
          content.css({
            "max-height": contentHeight + "px",
            position: "relative",
          });
        }

        // GSAP Pin Fix -- Adjusted for accordion animation completion
        if (!isMobile) {
          //ScrollTrigger.refresh(true);
        }
      });

      // Update heights on window resize
      $(window).resize(function () {
        $(".accordion-tab.open").each(function () {
          var content = $(this).find("dd");
          var newHeight = content.find(".content").outerHeight(true);
          content.css("max-height", newHeight + "px");
        });

        // ScrollTrigger.refresh();
      });
    }

    /*****************************************************************
      Call in GSAP Animations
    ******************************************************************/
    gsap.registerPlugin(ScrollTrigger);

    gsap.utils.toArray(".fade-in-up").forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          start: "top 85%",
          end: "bottom top",
          trigger: el,
          toggleClass: "show",
          once: true,
          pin: false,
        },
      });
    });

    gsap.utils.toArray(".fade-in").forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          start: "top 88%",
          end: "bottom top",
          trigger: el,
          toggleClass: "show",
          once: true,
          pin: false,
        },
      });
    });

    /*****************************************************************
      GSAP Image Marquee
    ******************************************************************/
    var MARQUEE_SPEED = 80;

    function waitForImages(container, callback) {
      var images = container.querySelectorAll("img");
      var remaining = images.length;
      if (remaining === 0) {
        callback();
        return;
      }
      var onDone = function () {
        remaining--;
        if (remaining <= 0) callback();
      };
      images.forEach(function (img) {
        if (img.complete) {
          onDone();
        } else {
          img.addEventListener("load", onDone);
          img.addEventListener("error", onDone);
        }
      });
    }

    var marqueeTimelines = [];

    function initImageMarquees() {
      marqueeTimelines.forEach(function (tl) {
        tl.kill();
      });
      marqueeTimelines = [];

      document
        .querySelectorAll(".marquee-image-section")
        .forEach(function (section) {
          var track = section.querySelector(".marquee-inner");
          if (!track) return;

          var clones = track.querySelectorAll("[data-marquee-clone]");
          clones.forEach(function (c) { c.remove(); });

          gsap.set(track, { clearProps: "x" });

          var originals = track.querySelectorAll(".content-contain");
          if (originals.length === 0) return;

          var isReversed = section.classList.contains("reversed");

          waitForImages(section, function () {
            var oneSetWidth = 0;
            originals.forEach(function (el) {
              oneSetWidth += el.offsetWidth;
            });

            if (oneSetWidth === 0) return;

            var viewportWidth = section.querySelector(".marquee-wrap").offsetWidth;
            var clonesNeeded = Math.ceil((viewportWidth * 2) / oneSetWidth);
            if (clonesNeeded < 1) clonesNeeded = 1;

            for (var c = 0; c < clonesNeeded; c++) {
              originals.forEach(function (el) {
                var clone = el.cloneNode(true);
                clone.setAttribute("data-marquee-clone", "");
                clone.setAttribute("aria-hidden", "true");
                track.appendChild(clone);
              });
            }

            var direction = isReversed ? 1 : -1;
            var distance = oneSetWidth * direction;
            var duration = Math.abs(oneSetWidth / MARQUEE_SPEED);

            if (isReversed) {
              gsap.set(track, { x: -oneSetWidth });
            }

            var tl = gsap.to(track, {
              x: isReversed ? 0 : distance,
              duration: duration,
              ease: "none",
              repeat: -1,
              modifiers: {
                x: function (x) {
                  var xNum = parseFloat(x);
                  if (isReversed) {
                    return (((xNum % oneSetWidth) + oneSetWidth) % oneSetWidth) - oneSetWidth + "px";
                  }
                  return (xNum % oneSetWidth) + "px";
                },
              },
            });

            marqueeTimelines.push(tl);
          });
        });
    }

    initImageMarquees();

    var marqueeResizeTimer;
    var marqueeLastWidth = window.innerWidth;
    $(window).on("resize.marquee", function () {
      var currentWidth = window.innerWidth;
      if (currentWidth === marqueeLastWidth) return;
      marqueeLastWidth = currentWidth;
      clearTimeout(marqueeResizeTimer);
      marqueeResizeTimer = setTimeout(function () {
        initImageMarquees();
      }, 300);
    });

    /***************************************************
      Stat Counter Handlers
    /*****************************************************/
    if ($(".stats-section").length) {
      gsap.utils.toArray(".counter-value").forEach((el) => {
        gsap.from(el, {
          scrollTrigger: {
            trigger: el,
            start: "top 85%",
            end: "bottom top",
            once: true,
            onEnter: () => {
              $(el)
                .prop("Counter", 0)
                .animate(
                  { Counter: $(el).attr("data-count") },
                  {
                    duration: 2000,
                    easing: "linear",
                    step: function (now) {
                      $(el).text(Math.floor(now));
                    },
                    complete: function () {
                      $(el).text(this.Counter);
                    },
                  },
                );
            },
          },
        });
      });
    }

    // Team Modal Handlers
    const openTeamModal = (event) => {
      const $button = $(event.currentTarget);
      const index = $button.data("index");
      const $memberBio = $(`.member-bio[data-index="${index}"]`);

      // Remove 'show' class from all bios
      $(".member-bio").removeClass("show");

      // Add 'show' class to the clicked bio
      $memberBio.addClass("show");

      // Add 'team-modal-active' class to body
      $("body").addClass("team-modal-active");
      $("#team-modal").attr("aria-hidden", "false").removeAttr("inert");
    };

    const closeTeamModal = () => {
      $("body").removeClass("team-modal-active");
      $("#team-modal").attr("aria-hidden", "true").attr("inert", "");

      // Remove 'show' class from all bios
      $(".member-bio").removeClass("show");
    };

    // Open team modal on button click
    $(".open-modal-btn").on("click", openTeamModal);

    // Close team modal on button click
    $(".close-modal-btn").on("click", closeTeamModal);

    // Close team modal on background click
    $(document).on("click", function (event) {
      if ($("body").hasClass("team-modal-active")) {
        const $target = $(event.target);
        if ($target.closest("#team-modal .container, .open-modal-btn").length === 0) {
          closeTeamModal();
        }
      }
    });

    // Close team modal on ESC key
    $(document).on("keydown", function (e) {
      if (e.key === "Escape" && $("body").hasClass("team-modal-active")) {
        closeTeamModal();
      }
    });

    /*****************************************************************
      Video Modal Handlers
    *****************************************************************/
    var $videoTrigger = null;

    const openVideoModal = (event) => {
      const $button = $(event.currentTarget);
      const videoUrl = $button.data("video-url");
      if (!videoUrl) return;

      $videoTrigger = $button;

      const iframe =
        '<iframe src="' +
        videoUrl +
        '?autoplay=1&rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="width:100%;height:100%;"></iframe>';

      $("#videoContainer-1").html(iframe);
      $("body").addClass("modal-open");
      $button.attr("aria-expanded", "true");
      $("#videoModal-1").attr("aria-hidden", "false");

      setTimeout(function () {
        $("#videoModal-1 .closeModalBtn").focus();
      }, 100);
    };

    const closeVideoModal = () => {
      $("#videoContainer-1").empty();
      $("body").removeClass("modal-open");
      $(".playVideoBtn").attr("aria-expanded", "false");
      $("#videoModal-1").attr("aria-hidden", "true");

      if ($videoTrigger && $videoTrigger.length) {
        $videoTrigger.focus();
        $videoTrigger = null;
      }
    };

    $(document).on("click", ".playVideoBtn", openVideoModal);

    $(document).on("click", "#videoModal-1 .closeModalBtn", closeVideoModal);

    $(document).on("click", "#videoModal-1", function (event) {
      if ($(event.target).closest(".modalVideoContainer, .closeModalBtn").length === 0) {
        closeVideoModal();
      }
    });

    $(document).on("keydown", function (e) {
      if (e.key === "Escape" && $("body").hasClass("modal-open")) {
        closeVideoModal();
      }
    });

    $(document).on("keydown", "#videoModal-1", function (e) {
      if (e.key !== "Tab") return;

      const $focusable = $("#videoModal-1").find('button, [href], iframe, [tabindex]:not([tabindex="-1"])');
      const $first = $focusable.first();
      const $last = $focusable.last();

      if (e.shiftKey && document.activeElement === $first[0]) {
        e.preventDefault();
        $last.focus();
      } else if (!e.shiftKey && document.activeElement === $last[0]) {
        e.preventDefault();
        $first.focus();
      }
    });
  });
})(jQuery);
